// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__V1W_M","movingOverlay":"style_movingOverlay__eT_mQ"};